/*********************** Custom JS for Boost AI Search & Discovery  ************************/
window.boostSDAppConfig.searchSettings.suggestionMobileStyle = "style2";
